module.exports = __webpack_public_path__ + "static/media/LeAvatar.afea5eb3.png";